<div class="softphone-timer">
    {{ counter | date:'mm:ss' }}
</div>
